// App.js
import React, { useState } from 'react';
import AdminLogin from './AdminLogin';
import AdminChat from './AdminChat';

const App = () => {
  const [admin, setAdmin] = useState(localStorage.getItem('adminUsername') || null);

  const handleLogin = (username) => {
    setAdmin(username);
  };

  return admin ? <AdminChat adminName={admin} /> : <AdminLogin onLogin={handleLogin} />;
};

export default App;
